import React, { useEffect, useRef, useState } from "react";
import { ListGroup } from "react-bootstrap";
import logo from "../Assets/images/avatar_.png";
import { IMessage } from "../@types/VideoCallTypes";
import "remixicon/fonts/remixicon.css";

type Props = {
  comments: IMessage[];
};

const SCROLL_OFFSET = 10;
const LiveComments: React.FC<Props> = ({ comments }) => {
  const endRef = useRef<HTMLDivElement | null>(null);
  const listRef = useRef<HTMLDivElement | null>(null);

  const prevLengthRef = useRef<number>(comments.length);

  const [showArrow, setShowArrow] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // 🔽 Scroll to bottom
const scrollToBottom = () => {
  if (!listRef.current) return;

  const scrollHeight = listRef.current.scrollHeight;
  const clientHeight = listRef.current.clientHeight;

  listRef.current.scrollTo({
    top: scrollHeight - clientHeight,
    behavior: "smooth",
  });

  setUnreadCount(0);
  setShowArrow(false);
};
  // 👀 Handle manual scroll
  const handleScroll = () => {
    if (!listRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = listRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - SCROLL_OFFSET;

    if (isAtBottom) {
      setUnreadCount(0);
      setShowArrow(false);
    } else {
      setShowArrow(true);
    }
  };

  useEffect(() => {
    if (!listRef.current) return;

    const newLength = comments.length;
    const prevLength = prevLengthRef.current;

    if (newLength <= prevLength) {
      prevLengthRef.current = newLength;
      return;
    }

    const newlyAdded = newLength - prevLength;

    const { scrollTop, scrollHeight, clientHeight } = listRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - SCROLL_OFFSET;

    if (isAtBottom) {
      scrollToBottom();
    } else {
      setUnreadCount((prev: any) => prev + newlyAdded);
      setShowArrow(true);
    }

    prevLengthRef.current = newLength;
  }, [comments]);
  console.log("comments===>", comments);
  return (
    <div className="live-comments comments--wraper">
      <p>Comment</p>
      <div
        ref={listRef}
        onScroll={handleScroll}
        style={{ maxHeight: "600px", overflowY: "auto" }}
      >
        <ListGroup variant="flush">
          {comments.map((comment, index) => (
            <ListGroup.Item key={index} className="comment-item">
              <div className="d-flex align-items-center">
                <img
                  src={
                    comment.user.profilePicture
                      ? comment.user.profilePicture
                      : logo
                  }
                  alt={comment.user.fullName}
                  width={35}
                  height={35}
                  className="rounded-circle me-2 m--comment--img"
                />
                <div>
                  <div className="comment-userw-name">
                    {comment.user.fullName}
                  </div>
                  <div className="comment--text">{comment.text}</div>
                </div>
              </div>
            </ListGroup.Item>
          ))}
          <div ref={endRef} />
        </ListGroup>
      </div>
      {showArrow && (
        <div className="scroll--down--arrow" onClick={scrollToBottom}>
          <i
            className="ri-arrow-down-double-line"
            style={{ color: "white", fontSize: "20px" }}
          ></i>
          {unreadCount > 0 && (
            <div
              className="no--of--comments"
              style={{
                background: "red",
                color: "white",
                borderRadius: "50%",
                padding: "2px 7px",
                fontSize: "12px",
              }}
            >
              {unreadCount}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LiveComments;
